import PurchaseBuyerHistory from '@/types/purchaseRequest/purchaseBuyerHistory'
import { BaseService } from './../../base'
export class PurchaseBuyerHistoryService extends BaseService<PurchaseBuyerHistory>() {
    static get entity (): string {
        return 'purchase_buyer_history'
    }
    static get responseName (): string {
        return 'purchase_buyer_history'
    }
}